<script setup>
import { computed, inject } from 'vue'

const userStore = inject('userStore')

// Comes from /api/account rather than the HTML: pages are stored in the response cache,
// which would otherwise show this admin bar to everyone.
const impersonate = computed(() => userStore.user?.impersonate ?? null)

const fullName = computed(() => [userStore.user?.firstName, userStore.user?.lastName].filter(Boolean).join(' ') || 'onbekend')
</script>

<template>
    <div v-if="impersonate" role="status" class="absolute z-5 left-0 right-0 md:left-1/2 md:right-auto md:-translate-x-1/2 flex items-center justify-between gap-4 rounded-b-lg bg-gray-900 px-4 py-1.5 text-sm text-white shadow-lg">
        <p>
            Dag <strong>{{ impersonate.firstName }}</strong>, je doet je nu voor als <strong>{{ fullName }}</strong>
            van <strong>{{ userStore.user.employer?.name || 'onbekend' }}</strong>.
        </p>
        <a href="/admin/impersonate/logout" class="inline-flex flex-none items-center gap-1.5 rounded bg-white/10 px-3 py-1 text-xs font-medium transition-colors hover:bg-white/20">
            <icon name="logout" class="size-4"></icon> Stoppen
        </a>
    </div>
</template>
